import { Button } from "@/components/button";
import { DeleteModal } from "@/components/delete-modal/delete-modal";
import { Icon } from "@/components/icon";
import { Text } from "@/components/text";
import { IMaterial } from "@/models/types";
import { deleteMaterial } from "@/reducers/materials-crud.reducer";
import { openModal } from "@/reducers/modal-reducer";
import { useAppDispatch } from "src/config/store";
import { MaterialsEdit } from "./materials-edit";

type Props = {
  material: IMaterial;
  className?: string;
};

const MaterialsCard = (props: Props) => {
  const { material, className } = props;

  const dispatch = useAppDispatch();

  const handleEdit = () => {
    dispatch(
      openModal({
        element: <MaterialsEdit material={material} />,
        opt: { size: "xs", title: "Modifica materiale" },
      })
    );
  };

  const handleDelete = () => {
    dispatch(
      openModal({
        element: (
          <DeleteModal
            message={`Confermi di voler eliminare il materiale ${material.post_title}?`}
            onConfirm={onDeleteConfirm}
            stateKey={"materialsCrud"}
          />
        ),
        opt: { size: "xs", title: "Elimina materiale" },
      })
    );
  };

  const onDeleteConfirm = () => {
    dispatch(deleteMaterial(material.ID));
  };

  return (
    <tr className={`table-item ${className || ""} `}>
      <td>{material.post_title}</td>
      <td>{material.createdAt && <Text type="date" format="DATETIME" content={material.createdAt} />}</td>
      <td>
        <div className="button-group justify-end">
          <Button size="sm" color="white" onClick={handleEdit}>
            <Icon content="edit" />
          </Button>
          <Button size="sm" color="white" onClick={handleDelete}>
            <Icon content="bin" />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default MaterialsCard;
